import styled from '@emotion/styled';
import { useSelector } from 'react-redux';

import { ASC, LOCATIONS_PAGE_SIZE, PAGE } from '../constants';

import LocationsHeader from './header/LocationsHeader';
import { LocationsTable } from './table/index.component';

interface Props {
  user: {
    primaryOrganizationId: string;
  };
  sortBy: string;
}

const LocationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5em;
`;

export const Locations = ({ sortBy }: Props) => {
  const user = useSelector((state: any) => state?.login?.user);

  return (
    <LocationsContainer>
      <LocationsHeader />
      <LocationsTable
        user={user}
        sortBy={sortBy}
        order={ASC}
        hideColumns={{}}
        hideFooter={false}
        context={PAGE}
        pageSize={LOCATIONS_PAGE_SIZE}
      />
    </LocationsContainer>
  );
};
